"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ArrowDoubleLeft;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ArrowDoubleLeft(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Arrows_",
    "data-name": "Arrows+"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "arrow-double-left"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline-4",
    "data-name": "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M41.863,50,80.1,11.768a2.5,2.5,0,0,0-3.535-3.536L37.18,47.612a3.387,3.387,0,0,0,0,4.778L76.559,91.768a2.5,2.5,0,1,0,3.535-3.536Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.842,50,63.074,11.768a2.5,2.5,0,0,0-3.535-3.536L20.158,47.612a3.389,3.389,0,0,0,0,4.778L59.537,91.768a2.5,2.5,0,1,0,3.535-3.536Z"
  })))));
}